import { render, staticRenderFns } from "./FeedTanksOverview.vue?vue&type=template&id=55329dca&"
import script from "./FeedTanksOverview.vue?vue&type=script&lang=ts&"
export * from "./FeedTanksOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports